import { useEffect, useRef } from 'react';
import services from '../services';

/**
 * Garante que exista um cenário favorito para o teste de estresse.
 *
 * @description
 * Após ser habilitado, verifica se a tela possui cenários favoritos e marca
 * o cenário Subprime como favorito quando necessário.
 *
 * @param {Object} pOptions - Opções de execução do hook
 * @param {boolean} pOptions.enabled - Indica quando a verificação pode ser iniciada
 * @param {boolean} pOptions.hasFavoritos - Indica se a tela possui cenários favoritos
 * @param {Function} pOptions.onModified - Callback executado após favoritar o cenário
 * @param {Function} pOptions.onError - Callback para erros da request
 */
const useCenarioFavoritoPadrao = (pOptions = {}) => {
  const {
    enabled: xEnabled = true,
    hasFavoritos: xHasFavoritos,
    onModified: xOnModified,
    onError: xOnError
  } = pOptions;
  const hasRequested = useRef(false);

  useEffect(() => {
    // Aguarda a lista da tela e preserva qualquer cenário já marcado como favorito.
    if (!xEnabled || xHasFavoritos || hasRequested.current) {
      return;
    }

    hasRequested.current = true;

    services.cenarios.modify(
      {
        cenario_id: '200805_SUBPRIME',
        favorito: true
      },
      () => {
        xOnModified && xOnModified();
      },
      rErr => {
        xOnError && xOnError(rErr);
      }
    );
  }, [xEnabled, xHasFavoritos, xOnError, xOnModified]);
};

export default useCenarioFavoritoPadrao;
